import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { IMultiSelectOption, IMultiSelectSettings } from 'angular-2-dropdown-multiselect';

import { CategorySelectOption } from './category-select-option';
import { CategoryQuery } from '@shared/queries';
import { Category, Language } from '@shared/data';

@Component({
  moduleId: 'module.id',
  selector: 'category-multiselect',
  styles: [require('./category-multiselect.component.scss')],
  template: require('./category-multiselect.component.html')
})
export class CategoryMultiselectComponent implements OnInit {
  @Input()
  public data: string[];

  @Output()
  public dataChange = new EventEmitter<string []>();

  public error: Parse.Error;
  public options: IMultiSelectOption[];
  public language: string;

  public settings: IMultiSelectSettings = {
    dynamicTitleMaxItems: 5
  };

  constructor(private translateService: TranslateService) {
    this.language = translateService.currentLang;
  }

  // ===============================================================================================
  // Override Methods
  // ===============================================================================================

  public ngOnInit(): void {
    this.fetchAll();
  }

  public onChange(event) {
   this.dataChange.emit(event);
  }

  // ===============================================================================================
  // Private Methods
  // ===============================================================================================

  private fetchAll() {
    let query = new CategoryQuery()
      .exists(Category.PARENT_KEY);

    query.find().then(
      (result: Category[]) => {
        this.options = result.map((category: Category): IMultiSelectOption => {
          return {
            id: category.id,
            name: category.name
          }
        });
      },
      (error: Parse.Error) => {
        this.error = error;
      }
    );
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+category/category-multiselect/category-multiselect.component.ts